module.exports = __webpack_public_path__ + "img/yidong2.6694ff68.png";